



































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import FileUpload from "vue-upload-component";

@Component({
  components: {
    FileUpload
  }
})
export default class EvidenceUpload extends Vue {
  files = [];
  uploadErrors = [];

  @Prop({ default: "jpeg|jpg|gif|png|bmp|pdf" })
  extensionsAllowed: string;

  @Prop()
  fileCountLimit: number;

  @Prop({ default: 1024 * 1024 * 10 })
  maxFileSize: number;

  @Prop()
  fileCount: number;

  get regex () {
    return new RegExp(".(" + this.extensionsAllowed + ")", "i");
  }

  get calculatedCount () {
    return this.fileCountLimit - this.fileCount - this.internalFileCount;
  }

  internalFileCount = 0;

  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (this.fileCountLimit && this.calculatedCount <= 0) {
        this.uploadErrors.push("Limit is " + this.fileCountLimit + " documents");
        return prevent();
      }
      if (!this.regex.test(newFile.name)) {
        this.uploadErrors.push(
            "Files must be in one of the following formats: " + this.extensionsAllowed.split("|").join(", "));
        return prevent();
      }
      if (newFile.size > this.maxFileSize) {
        this.uploadErrors.push("File must be smaller than " + this.maxFileSize / 1048576 + " MB");
        return prevent();
      }
      this.internalFileCount += 1;
    }
  }

  updateFiles (files) {
    const mappedFiles = files.map(f => f.file);
    this.$emit("onFiles", mappedFiles);
    this.internalFileCount = 0;
  }

  deleteFile (file) {
    const uploadComponent: any = this.$refs.upload;
    uploadComponent.remove(file);
  }

  clearErrors () {
    this.uploadErrors = [];
  }

  mounted () {
    // Reason:BEND-6906 WAVE tool returns an error on vue-upload-component
    // because it adds an empty label element while generating the template.
    document.querySelector("div.drag-container > div > div > span > label").innerHTML = "upload";
  }
}
